import { toast } from "react-toastify";
import { DropdownActions, DropdownItem } from "../../commons/DropdownActions";
import type { GetPayoutsResponse } from "../../../services/webServices/payouts/types";
import { patchPayout } from "../../../services/webServices/payouts/patch";

type Props = {
  payout: GetPayoutsResponse;
  onActionSuccessed: () => void;
};

export default function PayoutAction({ payout, onActionSuccessed }: Props) {

  const updatePayoutStatus = async (status: number): Promise<boolean> => {
    if (payout.status === status) {
      toast.info("وضعیت همین الان هم همین است");
      return false;
    }

    try {
      const success = await patchPayout({
        id: payout.id,
        body: { status }
      });

      if (!success) return false;

      toast.success("تغییر وضعیت با موفقیت انجام شد");
      onActionSuccessed();
      return true;
    } catch {
      return false;
    }
  };

  const actions: DropdownItem[] = [
    {
      key: "paid",
      tone: "success",
      label: "پرداخت شد",
      action: () => updatePayoutStatus(5),
    },
    {
      key: "rejected",
      tone: "error",
      label: "رد شد",
      action: () => updatePayoutStatus(6),
    },
  ];

  return (
    <DropdownActions
      items={actions}
      initialKey={
        payout.status === 5
          ? "paid"
          : payout.status === 6
          ? "rejected"
          : undefined
      }
      withoutInitKeyLabel="در انتظار پرداخت"
      disabled={payout.status !== 1}
    />
  );
};